import { useReducer, useCallback } from "react";

function httpReducer(state, action) {
  if (action.type === "SEND") {
    return {
      data: action.responseData,
      error: null,
      status: "pending",
    };
  }

  if (action.type === "SUCCESS") {
    return {
      data: action.responseData,
      error: null,
      status: "completed",
    };
  }

  if (action.type === "ERROR") {
    return {
      data: null,
      error: action.errorMessage,
      status: "completed",
    };
  }

  return state;
}

function useHttp2(
  requestFunction,
  startWithPending = false,
  initialData = null
) {
  const [httpState, dispatch] = useReducer(httpReducer, {
    status: startWithPending ? "pending" : null,
    data: initialData,
    error: null,
  });

  const sendRequest = useCallback(
    async function (...args) {
      dispatch({ type: "SEND", responseData: initialData });
      try {
        const responseData = await requestFunction(...args);
        dispatch({ type: "SUCCESS", responseData });
      } catch (error) {
        dispatch({
          type: "ERROR",
          errorMessage: error.message || "Something went wrong!",
        });
      }
    },
    [requestFunction, initialData]
  );

  return {
    sendRequest,
    ...httpState,
  };
}

export default useHttp2;
